import _ from "lodash"
import Activity from "./activity"
import Adventure from "./adventure"
import ShippingTypes from "./shippingTypes"
import Regions from "./regions"
import Api from "./api"
import Cookies from "./cookies"
import Validation from "./validation"
import Storage from "./storage"
import Tracking from "../util/tracking"
import Config from "../config"
import Util from "../util"
import ActivityPackages from "./activityPackages";

const data = {
  adventure:null, // the adventure currently assembled by the shopper
  purchase:null, // the most recent purchase // TODO do we ever use this?
  purchases:null, // completed purchases // TODO do we ever really need this ... all we do is set or get this from localStorage ...
  voucherValidation:null // voucher validated against the current cart, {valid, message, value}
}

const init = (reset) => {
  if(reset) {
    data.adventure = Adventure.createEmpty()
    Adventure.store(data.Adventure)
  }
  else {
    // attempt to restore from local storage
    _restoreAdventure() 
    _restorePurchases()
  }
  
}

/**
 * Adds an activity to the adventure and returns the updated adventure
 * @param {*} activity 
 * @param {*} regionCode 
 * @param {*} options 
 * @param {*} participantCount 
 * @param {*} subactivities
 */
const addActivity = (activity, regionCode, options, participantCount, subactivities) => {
  // no adventure yet? 
  if(!data.adventure) {
    data.adventure = Adventure.createEmpty()
  }

  // create the adventure activity
  let adventureActivity = Activity.createAdventureActivity(activity, regionCode, options, participantCount, subactivities)
  
  // add to cart
  removeActivity(activity._id)
  data.adventure.Activities.push(adventureActivity)

  // and update
  return updateAdventure()
}


const removeActivity = (activityId) => {
  let index = data.adventure.Activities.findIndex(a => {
    return a.Activity_ID === activityId
  })
  if(index >= 0) {
    data.adventure.Activities.splice(index, 1)
  }

  return updateAdventure()
}

const removeAllActivities = () => {
  data.adventure.Activities = [];
  return updateAdventure();
}

const getAdventure = () => {
  return data.adventure
}

const getAdventureRegion = () => {
  let regions = data.adventure.Region || []
  if(regions.length > 0) {
    return regions[0]
  }
  else {
    return null
  }
}

const getAdventureParticipantCount = () => {
  let counts = (data.adventure.Activities || []).map(a => Number(a.ParticipantCount));
  if(counts.length > 0) {
    return Math.max(...counts);
  }
  return undefined;
}

const getAdventureActivity = (activityId) => {
  if(data.adventure) {
    return data.adventure.Activities.find(aa => {
      return aa.Activity_ID === activityId
    })  
  }
  else {
    return null
  } 
}

const updateAdventure = () => {
  // set the adventure's region(s)
  Adventure.setRegions(data.adventure)  

  // calculate cost of all activities combined
  let activitiesCost = 0
  data.adventure.Activities.forEach(activity => {
    activitiesCost += activity.CalculatedPrice
  })

  // activity package included?
  let packageDiscount = 0;
  data.adventure.ActivityPackage = getActivityPackage();
  if(data.adventure.ActivityPackage) {
    packageDiscount = data.adventure.ActivityPackage.discount;
    activitiesCost -= packageDiscount;
  }

  // shipping cost
  let shippingCost = _.get(data.adventure, "Shipping.price") || 0
  
  // discount? 
  let voucherValidation = _evaluateVoucher(data.adventure.Voucher, activitiesCost)
  let totalDiscount = voucherValidation.value

  // apply values to adventure
  data.adventure.totalAdventureCost = activitiesCost - totalDiscount + shippingCost
  data.adventure.totalDiscount = totalDiscount
  data.voucherValidation = voucherValidation

  // store in browser storage and return
  Adventure.store(data.adventure)
  return data.adventure
}

const count = () => {
  if(data.adventure) {
    return (data.adventure.Activities || []).length
  }
  else {
    return 0
  }
}

const count2 = () => {
  if(data.adventure) {
    let count = (data.adventure.Activities || []).length;
    if(data.adventure.ActivityPackage) {
      let countPackageActivities = (data.adventure.ActivityPackage.activityIds || []).length;
      count = count - countPackageActivities + 1;
    }
    return count;
  }
  else {
    return 0;
  }
}

const getActivities = () => {
  if(data.adventure) {
    return data.adventure.Activities || []
  }
  else {
    return []
  }
}

const getAdventureActivitySummary = (adventureActivity) => {
  // TODO we are pretty optimistic here in terms of this never ever throwing any exeption
  return {
    region:Regions.getTitle(adventureActivity.RegionCode, "de"),
    participantCount:adventureActivity.ParticipantCount,
    price:adventureActivity.CalculatedPrice,
    options:adventureActivity.Options.map(o => {
      return {
        id:o.ID,
        title:o.ActivityOption.name["de"],
        unitCount:o.UnitCount,
        unitPrice:o.ActivityOption.price,
        price:o.UnitCount * o.ActivityOption.price
      }
    })
  }
}

const setShippingType = (shippingType) => {
  data.adventure.Shipping = shippingType
  data.adventure.Shipping_ID = shippingType._id
  return updateAdventure()
}

/**
 * Sets the adventure's id. We can do this after we intitialized the payment process in the API. From there we get the id back.
 * @param {string} adventureId 
 */
const setAdventureId = (adventureId) => {
  data.adventure.Id = adventureId;
  return updateAdventure();
}
const getAdventureId = () => {
  return data.adventure.Id;
}

const getShippingType = () => {
  return data.adventure.Shipping
}

// TODO I think quite a bit of this actually belongs to shippingTypes
const getShippingInfo = () => {
  let s = getShippingType()
  if(!s) {
    return null
  }
  
  // return the info
  return ShippingTypes.getInfo(s.code)
}

const getPersonalization = () => {
  return {
    ParticipantName: data.adventure.ParticipantName || "",
    SenderName: data.adventure.SenderName || "",
    Comments: data.adventure.Comments || "",
    OrderComments: data.adventure.OrderComments || "",
    Occasion: data.adventure.Occasion || "",
  }
}

const setPersonlization = (p) => {
  Object.keys(p).forEach(k => {
    data.adventure[k] = p[k] || ""
  })
  return updateAdventure()
}

const getPaymentAddress = (a) => {
  return {
    ClientFirstName:data.adventure.ClientFirstName || "",
    ClientName:data.adventure.ClientName || "",
    ClientCompany:data.adventure.ClientCompany || "",
    ClientAddress:data.adventure.ClientAddress || "",
    ClientAddress2:data.adventure.ClientAddress2 || "",
    ClientZip:data.adventure.ClientZip || "",
    ClientCity:data.adventure.ClientCity || "",
    ClientCountry: data.adventure.ClientCountry || (Config.country === "ch" ? "CH" : "DE"),
    ClientEmail:(data.adventure.ClientEmail || "").trim()
  }
}

const setPaymentAddress = (a) => {
  Object.keys(a).forEach(k => {
    data.adventure[k] = a[k] || ""
  })
  return updateAdventure()
}

const getShippingAddress = () => {
  
  return {
    ShippingFirstName:data.adventure.ShippingFirstName || "",
    ShippingName:data.adventure.ShippingName || "",
    ShippingCompany:data.adventure.ShippingCompany || "",
    ShippingAddress:data.adventure.ShippingAddress || "",
    ShippingAddress2:data.adventure.ShippingAddress2 || "",
    ShippingZip:data.adventure.ShippingZip || "",
    ShippingCity:data.adventure.ShippingCity || "",
    ShippingCountry:data.adventure.ShippingCountry || (Config.country === "ch" ? "CH" : "DE"),
  }
}
const setShippingAddress = (a) => {
  Object.keys(a).forEach(k => {
    data.adventure[k] = a[k] || ""
  })
  return updateAdventure()
}

const setShippingIsDifferent = (isDifferent) => {
  data.adventure.ShippingIsDifferent = isDifferent
  return updateAdventure()
}

const getShippingIsDifferent = () => {
  return data.adventure.ShippingIsDifferent || false
}

const setPaymentType = (paymentType) => {
  // make sure we have a valid payment type, if not, fallback
  const validTypes = Config.paymentTypes[Config.country];
  if(validTypes.includes(paymentType) === false) {
    paymentType = validTypes[0]
  }

  data.adventure.PaymentType = paymentType
  updateAdventure()
}

const getPaymentType = () => {
  return data.adventure.PaymentType || Config.paymentTypes[Config.country][0];
}

const getPurchases = () => {
  return data.purchases || []
}

const setVoucher = (voucher) => {
  data.adventure.Voucher = voucher
  updateAdventure()
}

const getVoucher = () => {
  return data.adventure.Voucher || null
}

const getVoucherValidation = () => {
  return data.voucherValidation
}

const getValidation = () => {
  const activitiesValidation = Validation.validateActivities(getActivities())
  const activities = activitiesValidation.valid
  const activitiesMessage = activitiesValidation.message
  // personalization
  const personalizationValidation = Validation.validatePersonalization(getPersonalization())
  const personalization = personalizationValidation.valid
  const personalizationMessage = personalizationValidation.message

  // payment
  const paymentValidation = Validation.validatePayment(getPaymentAddress(), getShippingIsDifferent(), getShippingAddress())
  const payment = paymentValidation.valid
  const paymentMessage = paymentValidation.message
  //const paymentErrors = paymentValidation.errorFields

  // terms
  const terms = data.adventure.TermsAccepted ? true : false

  // summary of invalid forms
  const errors = []
  if(!activities) errors.push(activitiesMessage)
  if(!personalization) errors.push("Personalisierung unvollständig")
  if(!payment) errors.push("Adresse unvollständig")
  if(!terms) errors.push("AGBs nicht akzeptiert")
  
  // TODO we might at the voucher validation in here as well ... to reduce the number of functions
  return {
    activities, 
    activitiesMessage,
    personalization, 
    personalizationMessage,
    payment, 
    paymentMessage,
    terms,

    errors:errors,
    valid:activities && personalization && payment && terms
  }
}

const getDefaultValidation = () => {
  return {
    activities:false, 
    personalization:false, 
    payment:false, 
    terms:false,

    personalizationMessage:"",
    paymentMessage:"",

    errors:[],
    valid:false
  }
}

const getTotalCost = () => {
  return data.adventure.totalAdventureCost || 0
}

const hasMinimalValue = () => {
  let voucher = getVoucher();
  let total = data.adventure.totalAdventureCost || 0
  //let discount = data.adventure.totalDiscount || 0
  let shipping = (data.adventure.Shipping || {price:0}).price || 0
  let value = total - shipping
  // if we have a voucher that counts total the min value, we add its value
  if(voucher && voucher.countsTowardsMinValue) {
    const discount = data.adventure.totalDiscount || 0;
    value += discount;
  }
  return value >= Config.minimalCartValue
}

const setValue = (key, value) => {
  data.adventure[key] = value
  return updateAdventure()
}

const getValue = (key) => {
  if(key === "totalAdventureCost") {
    // TODO any action necessary?
  }
  return data.adventure[key] || null
}

const submit = async(stripeTokenId) => {
  // attempt to read tracking medium and source from cookies
  let trackingSource = Cookies.set('utm_source') || ""
  let trackingMedium = Cookies.set('utm_medium') || ""

  // gather data we want to post
  let payload = {
    Adventure:data.adventure,
    StripeTokenId:stripeTokenId || null,
    TrackingSource:trackingSource,
    TrackingMedium:trackingMedium,
    //DisplayedAdventurePrice: data.adventure.totalAdventureCost // TODO the API uses this to check validity of price ... where else is it used, and why is not adventure.totalAdventureCost used directly?
  }

  // TODO try-catch this
  // execute payment and create the adventure
  let response = await Api.post('payandcreate', payload)

  if(response.ok) {
    let purchase = {
      date:new Date(),
      id:response.id,
      shippingCode:data.adventure.Shipping.code,
      receiverName:data.adventure.ParticipantName,
      reserverName:data.adventure.SenderName,
      cost:data.adventure.totalAdventureCost,
      shortUrl:response.shortUrl
    }

    // track the conversion (Google Analytics)
    Tracking.conversion(response.id, data.adventure.totalAdventureCost)

    // store the purchase in localStorage
    _storePurchase(purchase)

    // clear the cart
    _clearCart()
  }

  // return the response
  return response
}

/**
 * Calls the API to create the adventure in DB and a payrexx gateway 
 * We get the id of the adventure back and a payrexx gateway (if payrexx was selected)
 */
const initializePayrexx = async() => {
  // get the redirect url for payrexx payment page
  const baseUrl = Util.Payrexx.getRedirectUrl();

  // build the payload
  const payload = {
    Adventure:data.adventure,
    urlSuccess:baseUrl + "?payment=success",
    urlFailed:baseUrl + "?payment=failed",
    urlCancel:baseUrl + "?payment=cancel"
  }
  // get the gateway
  const response = await Api.post("initializepayrexx", payload);
  if(response.ok) {
    // set the adventure id so we can finalize the payment
    setAdventureId(response.id);
  }

  return response;
}

/**
 * Calls the API to finalize the adventure.
 * If the adventure was paid the API will send e-mail and slack message and return with response.success === true
 */
const finalizePayrexx = async() => {
  const adventureId = data.adventure.Id;
  // create the payload
  const payload = {
    adventureId
  }

  // unset the adventureId. to prevent the confirm page from finalizing this db object again
  setAdventureId(null); 

  // talk to api to check if the payment was successful
  const response = await Api.post("finalizepayrexx", payload);
  if(response.success) {
    let purchase = {
      date:new Date(),
      id: adventureId, //data.adventure.Id,
      shippingCode: data.adventure.Shipping.code,
      receiverName: data.adventure.ParticipantName,
      cost: data.adventure.totalAdventureCost,
      shortUrl: response.shortUrl
    }

    // track the conversion (Google Analytics)
    Tracking.conversion(response.id, data.adventure.totalAdventureCost)

    // store the purchase in localStorage
    _storePurchase(purchase)

    // clear the cart
    _clearCart()
  }
  return response;
}


const _storePurchase = (purchase) => {
  data.purchases.push(purchase)
  Storage.setPurchases(data.purchases)
}

const _clearCart = () => {
  // create a new empty adventure
  let newAdventure = Adventure.createEmpty()

  // copy user information (so user does not have to enter his name and address again)
  if(data.adventure) {
    let fields = ["ClientAddress", "ClientAddress2", "ClientCity", "ClientCompany", "ClientEmail", "ClientFirstName", "ClientName", "ClientZip", "ClientCountry"]
    fields.forEach(field => {
      newAdventure[field] = data.adventure[field] || null
    })
  }

  // store in local storage
  Adventure.store(newAdventure)

  // reset progress
  Storage.resetCheckoutProgress()

  // cache
  data.adventure = newAdventure
}

/**
 * Restores adventure from localStorage
 */
const _restoreAdventure = () => {
  // restore
  let adventure = Adventure.restore()
  // cache adventure
  data.adventure = adventure
  // update the adventure to validate voucher
  updateAdventure()
}

/**
 * Restores earlier purchases from localStorage
 */
const _restorePurchases = () => {
  let purchases = Storage.getPurchases()
  data.purchases = purchases
  return purchases
}

const _evaluateVoucher = (voucher, activitiesCost) => {
  // inline method that creates a result object
  let result = (valid, message, value) => { return {valid, message, value}}

  // do we have a voucher in the first place?
  if(!voucher) {
    return result(false, "Diesen Promocode gibt es leider nicht (mehr)", 0)
  }
  // single use and already used?
  if(voucher.singleUse && voucher.numberOfUses > 0) {
    return result(false, `Der Promocode '${voucher.code}' wurde bereits verwendet`, 0)
  }
  // minimum order value not achieved?
  if(activitiesCost < voucher.minOrderValue) {
    return result(false, `Der Promocode '${voucher.code}' ist leider erst ab einem Bestellwert von ${Config.currency} ${Number(voucher.minOrderValue).toFixed(2)} gültig`, 0)
  }
  // not yet / no longer valid?
  // TODO we also test this in the API ... why do that here again?
  let from = new Date(voucher.validFrom).setUTCHours(0, 0, 0, 0)
  let to = new Date(voucher.validTo).setUTCHours(23, 59, 59, 999)
  let now = new Date()
  if(now < from || now > to) {
    return result(false, `Der Promocode '${voucher.code}' ist leider noch nicht oder nicht mehr gültig`, 0)
  }
  // everything seems to be ok, calculate the value and return 
  let value
  if(voucher.kind === "percentage") {
    value = activitiesCost / 100 * (voucher.value || 0)
  }
  else {
    value = voucher.value || 0
  }
  return result(true, "Der Promocode ist gültig", value)
}

const getActivityPackage = () => {
  let info = undefined;  
  // get ids of activities in cart
  const a1 = data.adventure.Activities.map(a => String(a.Activity_ID));

  // iterate through all packages and check against activities in cart
  let participantCount = 0;
  let regionCode = null;
  const activityPackage = ActivityPackages.get().find(ap => {
    const a2 = (ap.activities || []).map(apa => apa.activityId);
    const missingActivities = _.difference(a2, a1);

    // not all all activities of the package found? abort
    if(missingActivities.length > 0) {
      return false;
    }

    // make sure all activities have the same region code and participant count
    const regionCodes = [];
    const participantCounts = [];
    ap.activities.forEach(apa => {
      const adventureActivity = data.adventure.Activities.find(a => a.Activity_ID === apa.activityId);
      participantCounts.push(adventureActivity.ParticipantCount);
      regionCodes.push(adventureActivity.RegionCode);
    })
    const uniqueParticipantCounts = _.uniq(participantCounts);
    const uniqueRegionCodes = _.uniq(regionCodes);
    if(uniqueParticipantCounts.length === 1 && uniqueRegionCodes.length === 1) {
      regionCode = uniqueRegionCodes[0];
      participantCount = uniqueParticipantCounts[0];
      return true;
    }

    // no valid match
    return false;
  })

  // found one? add additional info
  if(activityPackage) {
    // name of activities and total of activities
    const activityNames = [];
    const activityIds = [];
    let activitiesTotal = 0;
    activityPackage.activities.forEach(apa => {
      const activity = data.adventure.Activities.find(a => a.Activity_ID === apa.activityId);
      activityNames.push(activity.ActivityInfo.title);
      activityIds.push(activity.Activity_ID);
      activitiesTotal += activity.CalculatedPrice;
      // subtract option value from activity totals ... yes, this is a dirty hack ... should have a value for activity price without options and optionals
      (activity.Options || []).forEach(o => {
        const optionValue = o.UnitCount * o.ActivityOption.price;
        activitiesTotal -= optionValue;;
      });

    }); 

    // get the region variant && price configuration
    const regionVariant = activityPackage.regionVariants.find(rv => rv.regionCode === regionCode);
    const priceConfiguration = regionVariant.priceConfigurations.find(pc => pc.participantCount === participantCount);

    // the discount
    const discount = activitiesTotal - priceConfiguration.price;
    info = { 
      activityPackage,
      activityNames,
      activityIds,
      activitiesTotal,
      price: priceConfiguration.price,
      discount,
      priceConfiguration,
      regionCode
    };
  }
  
  // return what we found
  return info;
}

const removeActivityPackage = (activityPackage) => {
  activityPackage.activities.forEach(packageActivity => {
    let index = data.adventure.Activities.findIndex(adventureActivity => {
      return adventureActivity.Activity_ID === packageActivity.activityId;
    })
    if(index >= 0) {
      data.adventure.Activities.splice(index, 1)
    }
  })
  return updateAdventure()
}

export default {
  addActivity,
  removeActivity,
  removeAllActivities,

  setShippingType,
  getShippingType,

  getShippingInfo,

  getPersonalization,
  setPersonlization,

  getPaymentAddress,
  setPaymentAddress,

  getShippingAddress,
  setShippingAddress,

  getShippingIsDifferent,
  setShippingIsDifferent,

  getPaymentType,
  setPaymentType,

  setVoucher,
  getVoucher,

  getVoucherValidation,
  
  getValue,
  setValue,

  getPurchases,

  getAdventure,

  getValidation,
  getDefaultValidation,

  getTotalCost,

  getAdventureActivity,
  getAdventureActivitySummary,
  getActivities,
  getAdventureRegion,
  getAdventureParticipantCount,

  setAdventureId,
  getAdventureId,

  hasMinimalValue,

  count, // TODO should be named getActivitiesCount
  count2,
  init,

  submit,
  initializePayrexx,
  finalizePayrexx,

  getActivityPackage,
  removeActivityPackage
}